module.exports = __webpack_public_path__ + "static/media/noBrandSubscriptions.2cfaab25.svg";